import { SuppressExternallyManagedNotice } from 'externallyManaged/SuppressExternallyManagedNotice';
import { t, type I18nLocale } from '@ardoq/i18n';

type DialogContentProps = {
  numOfComponents: number;
  numOfReferences: number;
  i18nLocale: I18nLocale;
};

const getMessage = ({
  type,
  count,
  i18nLocale,
}: {
  type: 'component' | 'reference';
  count: number;
  i18nLocale: I18nLocale;
}) => {
  const isComponent = type === 'component';
  const isOne = count === 1;
  const keyBase = `externallyManaged:confirmDelete.${
    isComponent ? 'componentMessage' : 'referenceMessage'
  }`;
  const fallback = isComponent
    ? isOne
      ? 'This component was loaded from an external source. Your deletion may be overwritten and the component recreated on the next run of the load process.'
      : 'These components were loaded from an external source. Your deletion may be overwritten and the components recreated on the next run of the load process.'
    : isOne
      ? 'This reference was loaded from an external source. Your deletion may be overwritten and the reference recreated on the next run of the load process.'
      : 'These references were loaded from an external source. Your deletion may be overwritten and the references recreated on the next run of the load process.';
  const key = `${keyBase}_${isOne ? 'one' : 'other'}`;
  return (
    <>
      <p>{t(i18nLocale, key, fallback)}</p>
      <SuppressExternallyManagedNotice />
    </>
  );
};

const DialogContent = ({
  numOfComponents,
  numOfReferences,
  i18nLocale,
}: DialogContentProps) => {
  if (numOfComponents > 0) {
    return getMessage({
      type: 'component',
      count: numOfComponents,
      i18nLocale,
    });
  }

  if (numOfReferences > 0) {
    return getMessage({
      type: 'reference',
      count: numOfReferences,
      i18nLocale,
    });
  }

  return null;
};

export { DialogContent };
